const notes = [
  {
    id: 'opena',
    note: 'A',
    imgUrl: 'opena',
    string: 'A',
    position: 'open',
  },
  {
    id: 'astringb',
    note: 'B',
    imgUrl: 'astringb',
    string: 'A',
    position: '1',
  },
  {
    id: 'astringc',
    note: 'C',
    imgUrl: 'astringc',
    string: 'A',
    position: '2',
  },
  {
    id: 'opend',
    note: 'D',
    imgUrl: 'opend',
    string: 'D',
    position: 'open',
  },
  {
    id: 'dstringe',
    note: 'E',
    imgUrl: 'dstringe',
    string: 'D',
    position: '1',
  },
  {
    id: 'dstringf',
    note: 'F#',
    imgUrl: 'dstringf',
    string: 'D',
    position: '2',
  },
  {
    id: 'openg',
    note: 'G',
    imgUrl: 'openg',
    string: 'G',
    position: 'open',
  },
  {
    id: 'gstringa',
    note: 'A',
    imgUrl: 'gstringa',
    string: 'G',
    position: '1',
  },
  {
    id: 'gstringb',
    note: 'B',
    imgUrl: 'gstringb',
    string: 'G',
    position: '2',
  },
  {
    id: 'opene',
    note: 'E',
    imgUrl: 'opene',
    string: 'E',
    position: 'open',
  },
  {
    id: 'estringf',
    note: 'F#',
    imgUrl: 'estringf',
    string: 'E',
    position: '1',
  },
  {
    id: 'estringg',
    note: 'G',
    imgUrl: 'estringg',
    string: 'E',
    position: '2',
  },
];

export default notes;
